<template>
  <div>
    <!--Route Related Geographies-->
    <template v-for="route in routes" v-if="showRoutes">
      <gmap-polyline
        :key="`r-${route.id}`"
        :path="getPath(route)"
        :options="getPathOptions(route)"
        @click="selectRoute(route)"
        v-if="getPath(route)"
      ></gmap-polyline>

      <gmap-marker
        v-for="stop in route.Stops"
        :key="`stop-${stop.id}`"
        :position="stop.point"
        @click="selectRoute(route)"
      ></gmap-marker>
    </template>

    <gmap-marker
      v-for="location in hubs"
      :key="`cl-${location.id}`"
      :position="location.point"  
      :icon="getIcon('CollectionLocation', location)"
      v-if="location && location.point"
    ></gmap-marker>

    <gmap-marker
      v-for="location in locations"
      :key="`pl-${location.location.id}`"
      :position="location.location.point"
      :icon="getIcon(location.type, location.entity)"
      :options="{ zIndex: getIcon(location.type, location.entity).zIndex }"
      v-if="location && location.location.point"
      @click="selectLocation(location)"
    ></gmap-marker>

    <div class="box has-text-centered is-add-stop">
      <p>
        <strong>Route: </strong>
        <span v-if="route">
          {{ route.name }}
          <button type="button" class="delete" @click="route = null"></button>
        </span>
        <span v-else>Select a Route</span>
      </p>

      <p>
        <strong>Location: </strong>
        <span v-if="location">
          {{ location.location.name }}
          <button type="button" class="delete" @click="location = null"></button>
        </span>
        <span v-else>Select a Location</span>
      </p>

      <div class="buttons is-right" v-if="route && location">
        <button type="button" class="button is-success">Add Stop</button>
      </div>
    </div>
  </div>
</template>

<script>
import * as MapperHelpers from '../MapperHelpers'

export default {
  name: 'AddStopOverview',

  props: [
    'status',
    'routes',
    'locations',
    'hubs'
  ],

  data () {
    return {
      route: null,
      location: null,

      showRoutes: true
    }
  },

  methods: {
    getIcon: MapperHelpers.getIcon,
    getPath: MapperHelpers.getPath,
    getPathOptions: MapperHelpers.getPathOptions,

    selectRoute (route) {
      if (route.Stops.length < 23) {
        this.route = route
      } else {
        this.$handleError('You cannot add a stop to this route. A route can only have 23 stops.')
      }
    },

    selectLocation (location) {
      this.location = location
    },

    async addStop () {
      if (this.route && this.location) {

      } else {
        this.$handleError('You must have both a route and location selected')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .box.is-add-stop {
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    position: absolute;
    top: 3rem;
    left: 50%;
    transform: translateX(-50%);
    width: 25vw;
  }
</style>
